import * as _ from 'lodash';

let _corpus = {};

const updateScriptArea = () => {
  window.dispatchEvent(new CustomEvent("updateScripGutter"));
};

const updateScriptAreaWithDebounce = _.debounce(() => {
  updateScriptArea();
}, 2000);


const CorpusStatusKeeper = {
  clean: () => {
    _corpus = {};
  },
  add: (corpusInfo) => {
    if (corpusInfo) {
      const { location, complete } = corpusInfo;
      const { file, line } = location;
      if (file && line) {
        _corpus[`${file}-${line}`] = complete;
        if (complete === false) {
          updateScriptArea();
        } else {
          updateScriptAreaWithDebounce();
        }
      }
    }
  },
  isIndexing: (scriptName, corpusLine) => {
    return _corpus[`${scriptName}-${corpusLine}`] === false;
  }
};

(window as any).CorpusStatusKeeper = CorpusStatusKeeper;
(window as any)._corpus = _corpus;

export default CorpusStatusKeeper;